<template>
  <div class="detaul-box">
    <el-form
      :rules="pageType === 3 ? undefined : rules"
      class="form-box"
      ref="form"
      :model="form"
      label-width="255px"
    >
      <div class="title">基本信息</div>
      <el-form-item prop="itemName" label="服务项目名称：">
        <div v-if="pageType === 3">{{ form.itemName }}</div>
        <el-input
          v-else
          clearable
          maxlength="50"
          v-model="form.itemName"
          placeholder="请输入服务项目名称，限制50个字符"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="pageType === 3" label="服务项目编码：">
        <div>{{ form.itemCode }}</div>
      </el-form-item>
      <el-form-item prop="showName" label="对外展示名称：">
        <div v-if="pageType === 3">{{ form.showName }}</div>
        <el-input
          v-else
          clearable
          v-model="form.showName"
          maxlength="50"
          placeholder="请输入对外展示名称，限制50个字符"
        ></el-input>
      </el-form-item>
      <el-form-item prop="serviceType" label="服务类别：">
        <el-cascader
          clearable
          :class="{ 'cascader-w': pageType === 3 }"
          class="service_disabled"
          :disabled="pageType === 3"
          placeholder="请选择服务类别"
          v-model="form.serviceType"
          :options="selectServiceTypeList"
          :props="{
            expandTrigger: 'hover',
            value: 'id',
            label: 'name',
            emitPath: false,
          }"
          @change="serviceTypeChange($event, false)"
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="serviceModeId" label="服务提供方式：">
        <el-cascader
          clearable
          :class="{ 'cascader-w': pageType === 3 }"
          class="service_disabled"
          :disabled="pageType === 3"
          placeholder="请选择服务提供方式"
          v-model="form.serviceModeId"
          :options="selectserviceModeList"
          :props="{
            expandTrigger: 'hover',
            value: 'id',
            label: 'name',
            emitPath: false,
          }"
          @change="singleCheck('serviceModeId')"
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="itemStatus" label="状态：">
        <div v-if="pageType === 3">
          {{ form.itemStatus == "ON" ? "启用" : "" }}
          {{ form.itemStatus == "OFF" ? "停用" : "" }}
        </div>
        <el-radio-group
          v-else
          v-model="form.itemStatus"
          @change="singleCheck('itemStatus')"
        >
          <el-radio label="ON">启用</el-radio>
          <el-radio label="OFF">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="核心系统编码：">
                <div v-if="pageType === 3">{{ form.number }}</div>
                <el-input
                    v-else
                    v-model="form.number"
                    placeholder="请输入核心系统编码"
                ></el-input>
            </el-form-item> -->
      <!-- <el-form-item label="服务描述：">
        <div v-if="pageType === 3">{{ form.itemDesc }}</div>
        <el-input
          v-else
          clearable
          v-model="form.itemDesc"
          maxlength="200"
          placeholder="请输入服务描述，限制200个字符"
          type="textarea"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="服务项目描述：">
        <div v-if="pageType === 3" v-html="form.itemDesc"></div>
        <div v-else>
          <quill-editor
            v-model="form.itemDesc"
            @change="quillChange($event, 'miaoshu')"
            :options="{ placeholder: '请输入服务项目描述' }"
          ></quill-editor>
        </div>
      </el-form-item>
      <!-- <el-form-item label="服务项目详情：">
        <quill-editor
          :toolbar="false"
          v-model="form.desc"
          @change="quillChange($event, 'xiangmu')"
        ></quill-editor>
      </el-form-item> -->
      <el-form-item label="服务内容：">
        <div v-if="pageType === 3" v-html="form.itemContents"></div>
        <div v-else>
          <quill-editor
            v-model="form.itemContents"
            @change="quillChange($event, 'neirong')"
            :options="{ placeholder: '请输入服务内容' }"
          ></quill-editor>
        </div>
      </el-form-item>
      <el-form-item label="服务流程：">
        <div v-if="pageType === 3" v-html="form.itemProcess"></div>
        <div v-else>
          <quill-editor
            v-model="form.itemProcess"
            @change="quillChange($event, 'liucheng')"
            :options="{ placeholder: '请输入服务流程' }"
          ></quill-editor>
        </div>
      </el-form-item>
      <el-form-item label="服务标准：">
        <div v-if="pageType === 3" v-html="form.itemStandards"></div>
        <div v-else>
          <quill-editor
            v-model="form.itemStandards"
            @change="quillChange($event, 'biaozhun')"
            :options="{ placeholder: '请输入服务标准' }"
          ></quill-editor>
        </div>
      </el-form-item>
      <el-form-item label="服务须知：">
        <div v-if="pageType === 3" v-html="form.itemNotice"></div>
        <div v-else>
          <quill-editor
            v-model="form.itemNotice"
            @change="quillChange($event, 'xuzhi')"
            :options="{ placeholder: '请输入服务须知' }"
          ></quill-editor>
        </div>
      </el-form-item>
      <div class="title">供应商服务</div>
      <el-form-item prop="service" label="关联“供应商-服务项目”：">
        <div v-if="pageType === 3">
          <el-tag
            class="el-tag"
            v-for="(el, i) in form.providerServicenameList"
            :key="i"
          >
            {{ el }}
          </el-tag>
        </div>
        <el-cascader
          class="cascader-service"
          v-else
          clearable
          :props="{
            expandTrigger: 'hover',
            multiple: true,
            value: 'id',
            label: 'serviceName',
            children: 'serviceList',
            emitPath: false,
          }"
          :disabled="!form.serviceType"
          v-model="form.serviceIdList"
          placeholder="请选择供应商服务"
          :options="cascaderOptions"
          :show-all-levels="true"
          @visible-change="showService"
          @change="changeService"
        ></el-cascader>
      </el-form-item>
      <!-- <div class="title">服务详情编辑</div>
      <el-form-item label="服务详情">
        <quill-editor v-model="form.content"></quill-editor>
      </el-form-item> -->
      <!-- <div class="title">服务详情编辑</div>
      <el-form-item label="服务详情1">
        <el-input
          v-model="form.content2"
          autosize
          placeholder="请输入内容"
          maxlength="1000"
          type="textarea"
        >
        </el-input>
      </el-form-item> -->

      <div class="title">服务属性</div>
      <template>
        <el-form-item
          prop="genderLimit"
          label="性别："
          v-if="genderLimitVisible"
        >
          <div v-if="pageType === 3">
            {{ form.genderLimit | filterValue(gerderList) }}
          </div>
          <el-select
            v-else
            v-model="form.genderLimit"
            placeholder="请选择性别"
            clearable
          >
            <el-option
              v-for="item in gerderList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="marryLimit" label="婚姻：" v-if="marryLimitVisible">
          <div v-if="pageType === 3">
            {{ form.marryLimit | filterValue(marryList) }}
          </div>
          <el-select
            v-else
            v-model="form.marryLimit"
            placeholder="请选择婚姻"
            clearable
          >
            <el-option
              v-for="item in marryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item>
        <div class="button-box">
          <el-button
            class="search-btn"
            v-if="pageType != 3"
            type="primary"
            @click="onSubmit"
            >{{ submitText }}</el-button
          >
          <el-button class="search-btn" @click="toBack">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import getService from "@/mixins/getService.mixin";
import { mapGetters } from "vuex";
import { gerderList, marryList } from "@/assets/js/options";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: "detail",
  mixins: [getService],
  components: { quillEditor },
  data() {
    // 获取页面状态 1：新增 2：编辑 3：查看
    let pageType = 1;
    this.$route.name === "serviceItemsEdit" && (pageType = 2);
    this.$route.name === "serviceItemsDetail" && (pageType = 3);
    // 验证规则
    const serviceValidator = (rule, value, callback) => {
      try {
        let list = this.form.serviceIdList;
        if (!list || list.length == 0) {
          callback(Promise.reject());
        } else {
          callback();
        }
      } catch (err) {
        callback(Promise.reject());
      }
    };

    return {
      genderLimitVisible: false, // 性别显示隐藏
      marryLimitVisible: false, // 性别显示隐藏
      serviceTypeList: [], // 服务类型列表
      id: this.$route.query.id || "",
      pageType, // 1：新增 2：编辑 3：查看
      // submit按钮文字
      submitText: {
        1: "立即创建",
        2: "编辑",
        3: "",
      }[pageType],
      // 导航、提示文字
      breadcrumbName: {
        1: "新增",
        2: "编辑",
        3: "查看",
      }[pageType],
      form: {
        serviceIdList: [],
        itemName: undefined,
        showName: undefined,
        serviceType: undefined,
        serviceModeId: undefined,
        itemStatus: undefined,
        itemDesc: "",
        providerServicenameList: undefined,
        genderLimit: "NONE",
        marryLimit: "NONE",
        content: "",
      }, // 数据
      cascaderOptions: [], // 供应商服务List
      gerderList,
      marryList,
      // 校验规则
      rules: {
        itemName: [
          {
            required: true,
            message: "请输入服务项目名称",
            trigger: "blur",
          },
        ],
        showName: [
          {
            required: true,
            message: "请输入对外展示名称",
            trigger: "blur",
          },
        ],
        serviceType: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: "blur",
          },
        ],
        serviceModeId: [
          {
            required: true,
            message: "请选择服务提供方式",
            trigger: "blur",
          },
        ],
        itemStatus: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
        service: [
          {
            required: true,
            message: "请选择供应商服务",
            validator: serviceValidator, // 自定义校验
            trigger: "blur",
          },
        ],
        genderLimit: [
          { required: true, message: "请选择性别", trigger: "blur" },
        ],
        marryLimit: [
          { required: true, message: "请选择婚姻", trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    filterValue(text, data) {
      return (
        data.find((item) => {
          if (text === item.value) {
            return item;
          }
        })?.label || text
      );
    },
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "服务项目", link: "" },
      { name: "服务项目管理", link: "" },
      { name: this.breadcrumbName, link: "" },
    ];
  },
  async mounted() {
    if (!this.authMap["sa_item_view"]) {
      this.$message.error("抱歉，您暂无权限");
      return;
    }
    await this.getCascaderOptions(); // 获取供应商服务list
    if (this.pageType != 1) {
      await this.getData(); // 获取数据
    }
  },
  computed: {
    ...mapGetters(["authMap"]),
  },
  methods: {
    quillChange({ quill, html, text }, type) {
      // console.log(quill, html, text, type);
      console.log(text.length);
      if (type == "miaoshu") {
        if (text.length > 1001) {
          this.form.itemDesc = text.substr(0, 1000);
          // this.$message.warning("");
          alert("已超出字数");
        }
      }
      // else if (type == "xiangmu") {
      //   if (text.length > 1001) {
      //     this.form.itemDesc = text.substr(0, 1000);
      //     // this.$message.warning("");
      //     alert("已超出字数");
      //   }
      // }
      else if (type == "neirong") {
        if (text.length > 1001) {
          this.form.itemDesc = text.substr(0, 1000);
          // this.$message.warning("");
          alert("已超出字数");
        }
      } else if (type == "liucheng") {
        if (text.length > 1001) {
          this.form.itemDesc = text.substr(0, 1000);
          // this.$message.warning("");
          alert("已超出字数");
        }
      } else if (type == "biaozhun") {
        if (text.length > 1001) {
          this.form.itemDesc = text.substr(0, 1000);
          // this.$message.warning("");
          alert("已超出字数");
        }
      } else if (type == "xuzhi") {
        if (text.length > 1001) {
          this.form.itemDesc = text.substr(0, 1000);
          // this.$message.warning("");
          alert("已超出字数");
        }
      }
    },
    getPreview() {},
    /**
     * 单独校验某个字段输入，清除错误提示
     * @param {String} name 输入名
     */
    singleCheck(name) {
      this.$refs.form.validateField(name, (val) => {
        if (!val) {
          return true;
        } else {
          return false;
        }
      });
    },
    /**
     * 服务类型change
     * @param {Boolean} isCreated 是否是在加载时执行该函数，如果是则不重置数据
     */
    async serviceTypeChange(isCreated = false) {
      console.log("服务类型选择");
      await this.getCascaderOptions(); // 获取供应商服务list
      this.getServiceAttribute();
      if (!isCreated) {
        this.singleCheck("serviceType");
        this.form.serviceIdList = [];
        this.form.genderLimit = "NONE";
        this.form.marryLimit = "NONE";
      }
    },
    //下拉框出现/隐藏时触发
    showService(value) {
      console.log("changeService", value);
      if (value && this.cascaderOptions.length == 0) {
        document.querySelector(
          ".is-empty .el-cascader-menu__empty-text"
        ).innerHTML = "无法关联，请先完成供应商服务配置！";
      }
    },
    // 修改一二级连接符
    changeService(value) {
      this.singleCheck("service");
      setTimeout(() => {
        let domList = document.querySelectorAll(
          ".cascader-service .el-cascader__tags .el-tag span"
        );
        domList.forEach((item) => {
          item.innerHTML = item.innerText.replace(/\//g, "-");
        });
      }, 200);
    },
    /**
     * 是否显示服务属性
     */
    getServiceAttribute() {
      var getServiceAttributeData = (list, id) => {
        let data = undefined;
        for (let i = 0; i < list.length; i++) {
          if (list[i].id === id) return list[i];
        }
        for (let i = 0; i < list.length; i++) {
          if (list[i]?.children?.length) {
            let d = getServiceAttributeData(list[i].children, id);
            d && (data = d);
          }
        }
        return data;
      };
      let l = this.serviceTypeList;
      let id = this.form.serviceType;
      let data = getServiceAttributeData(l, id) || {};
      data.genderPropertyFlag === "YES"
        ? (this.genderLimitVisible = true)
        : (this.genderLimitVisible = false);
      data.maritalPropertyFlag === "YES"
        ? (this.marryLimitVisible = true)
        : (this.marryLimitVisible = false);
    },
    /**
     * 提交（新建、修改）
     */
    async onSubmit() {
      console.log(JSON.stringify(this.form.content));
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false;
        let params = Object.assign({ id: this.id || undefined }, this.form);
        // 服务类型数组取字符串处理
        if (params.serviceType?.length) {
          params.serviceType =
            params.serviceType[params.serviceType.length - 1];
        }
        // 服务提供方式数组取字符串处理
        if (params.serviceModeId?.length) {
          params.serviceModeId =
            params.serviceModeId[params.serviceModeId.length - 1];
        }
        let api = {
          1: "itemServiceCreate",
          2: "itemServiceEdit",
        }[this.pageType];
        let res = await this.axios.post(this.getApiUrl(api), params, {
          toJSON: true,
        });
        if (res?.code === 1) {
          this.$message.success(`${this.breadcrumbName}成功`);
          this.$router.go(-1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * 后退
     */
    toBack() {
      this.$router.go(-1);
    },
    /**
     * 获取供应商服务list
     */
    async getCascaderOptions() {
      let res = await this.axios.get(this.getApiUrl("itemServiceList"), {
        params: {
          serviceType: this.form.serviceType,
        },
      });
      let data = res?.data || [];
      data.forEach((item) => {
        // if (item.providerAbbr) item.serviceType = item.providerAbbr;
        if (item.providerName) item.serviceName = item.providerName;
      });
      console.log("cascaderOptions", data);
      this.cascaderOptions = data; // 测试数据
    },
    /**
     * 获取数据
     */
    async getData() {
      console.log("no");
      let res = await this.axios.get(this.getApiUrl("itemServiceView"), {
        params: {
          itemId: this.id,
        },
      });
      let data = res.data;
      // 处理 选择供应商服务 数据回显
      if (data?.providerServiceList?.length) {
        let list = [];
        let nameList = [];
        data.providerServiceList.forEach((item) => {
          if (item?.serviceList?.length) {
            item.serviceList.forEach((el) => {
              list.push(el.id);
              nameList.push(item.providerAbbr + " - " + el.serviceName);
            });
          }
        });
        data.serviceIdList = list;
        data.providerServicenameList = nameList;
      }
      this.form = data;
      this.$refs.form.clearValidate();
      this.serviceTypeChange(true);
      setTimeout(() => {
        let domList = document.querySelectorAll(
          ".cascader-service .el-cascader__tags .el-tag span"
        );
        domList.forEach((item) => {
          item.innerHTML = item.innerText.replace(/\//g, "-");
        });
      }, 200);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.preview {
  width: 320px;
  height: 568px;
  line-height: 24px;
  overflow: hidden;
  img {
    width: 100%;
    margin: 20px 0;
  }
}

.detaul-box {
  .form-box {
    max-width: 750px;
    .title {
      height: 30px;
      line-height: 30px;
      margin-bottom: 40px;
      font-weight: bold;
      padding-left: 20px;
      position: relative;
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 8px;
        background-color: $theme;
      }
    }
  }
  .button-box {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 100px;
  }
  // elementUI样式丢失？补充
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .cascader-w {
    width: 900px;
  }
}
</style>

<style lang="scss">
.ql-toolbar.ql-snow {
  height: 0;
  padding: 0;
  border-top: 0;
}
.ql-toolbar.ql-snow .ql-formats {
  display: none;
}
.detaul-box {
  .service_disabled {
    width: 100%;
    .el-input.is-disabled {
      .el-input__inner {
        background-color: #fff;
        border: none;
        padding: 0;
        color: #535353;
        cursor: auto;
      }
      .el-input__suffix {
        display: none;
      }
    }
  }
}
</style>
